import { html, TemplateResult } from 'lit';
import { BreachPathNode, BreachPathNodeDefaultMetadata } from '../types';
import { BaseWebComponentTranslator } from 'apps/webcomponents/src/framework/BaseWebComponentTranslator';
import { CloudProviders } from 'apps/webcomponents/src/riskManagement/common/constants';

export function resourceNameRenderer(rowData: { item: BreachPathNode }): TemplateResult {
  return html`<span class="cell-label">${rowData.item.name ?? '-'}</span>`;
}

export function resourceIdRenderer(rowData: { item: BreachPathNode }): TemplateResult {
  try {
    const metadata: BreachPathNodeDefaultMetadata = JSON.parse(rowData.item.metadata);
    return html`<span class="cell-label">${metadata.resource_id}</span>`;
  } catch {
    return html`<span class="cell-label">${'-'}</span>`;
  }
}

export function resourceTypeRenderer(rowData: { item: BreachPathNode }): TemplateResult {
  return html`<span class="cell-label">${BaseWebComponentTranslator.getInstance().getDeviceTypes(rowData.item.type) || '-'}</span>`;
}

export function platformRenderer(rowData: { item: BreachPathNode }): TemplateResult {
  try {
    const metadata: BreachPathNodeDefaultMetadata = JSON.parse(rowData.item.metadata);

    let provider;
    
    if (metadata.provider === 'aws') {
      provider = CloudProviders.AWS;
    } else if (metadata.provider === 'gcp') {
      provider = CloudProviders.GCP;
    } else if (metadata.provider === 'azr') {
      provider = CloudProviders.AZURE;
    }

    return html`<span class="cell-label">${BaseWebComponentTranslator.getInstance().getOperatingSystem(provider) ?? '-'}</span>`;
  } catch {
    return html`<span class="cell-label">${'-'}</span>`;
  }
}
